import axios from "axios";
// export default axios.defaults.baseURL = "https://consultancy-api.iid.org.in"
// export default axios.defaults.baseURL = "http://localhost:8080/"
export default axios.defaults.baseURL = "https://admin.cmyuva.org.in/"
